import { sentenceCase } from "@/helpers/formatting.helper";

export const getters = {
  clientOutOfDate: state => {
    const build = state.details.client_build;
    return build && build != process.env.VUE_APP_CLIENT_BUILD;
  },
  testingToolsEnabled: state => {
    return state.details.testing_tools_enabled && !state.details.disableTestingTools;
  },
  mfaMode: state =>{
    const mfaMode = state.details.mfa_mode;
    return mfaMode == null ? "UNKNOWN" : `${mfaMode}`;
  },
  showingGlobalError: state => {
    return state.globalError.show;
  },
  environmentForToolbar: state => {
    const env = state.details.environment;
    return env == "production" || env == null ? "" : `(${sentenceCase(env)})`;
  }
};
